export const config = {
  PartnersIntro: {
    title: 'Select a Guide',
    description: 'Our highly skilled Beauty Guides are total experts in make-up and skincare. They are your own personal shopper for Beauty, who will get to know you and help find tailored solutions to leave you feeling more you than ever before.',
  },
};
